import { render, staticRenderFns } from "./MessagesContact.vue?vue&type=template&id=59d2d64f&"
import script from "./MessagesContact.vue?vue&type=script&lang=js&"
export * from "./MessagesContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports